import Vue from 'vue'
import Router from 'vue-router'
import SignIn from './views/auth/SignIn.vue'
import Main from './views/Main.vue'
import Item from './views/contents/Item.vue'
import Banner from './views/contents/Banner.vue'
import Category from './views/contents/Category.vue'
import Producer from './views/contents/Producer.vue'
import Push from './views/contents/Push.vue'
import Order from './views/user/Order.vue'
import Admin from './views/admin/Admin.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: '/top'
    },
    {
      path: '/signin',
      name: 'signin',
      component: SignIn
    },
    {
      path: '/top',
      name: 'main',
      component: Main
    },
    {
      path: '/item',
      name: 'item',
      component: Item
    },
    {
      path: '/banner',
      name: 'banner',
      component: Banner
    },
    {
      path: '/category',
      name: 'category',
      component: Category
    },
    {
      path: '/producer',
      name: 'producer',
      component: Producer
    },
    {
      path: '/push',
      name: 'push',
      component: Push
    },
    {
      path: '/order',
      name: 'order',
      component: Order
    },
    {
      path: '/admin',
      name: 'admin',
      component: Admin
    }
  ]
})
